import { render, staticRenderFns } from "./Chapter3_2.vue?vue&type=template&id=15b233ab&scoped=true&"
import script from "./Chapter3_2.vue?vue&type=script&lang=js&"
export * from "./Chapter3_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b233ab",
  null
  
)

export default component.exports